import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;
    this.state = {
      APIKey: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    const { softwares } = this.props;
    const { zenotiData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    console.log('props', this.props);
    this.setState({
      ...((zenotiData.APIKey || form.APIKey) && {APIKey: form.APIKey?form.APIKey:zenotiData.APIKey}),
    });
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value.replace(/[^a-zA-Z0-9]/g, ""),
    });
  }

  onNextButtonClick() {
    const { APIKey } = this.state
    
    const data = {
      client:'OPEN_DENTAL',
      APIKey,
      zone_id: this.props.zone_id
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
      this.props.storeZentiData(data)
    }
  }

  validate(data) {
    if (!(data.APIKey)) {
        this.setState({
          mandatoryFieldError: true,
        });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const {APIKey, mandatoryFieldError} = this.state
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {(softwares.isAuthError || softwares.isBookerAccountInfoSaveFail) ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              {softwares.errorMessage || 'Unable to save API key'}
            </p>
          ) : null}
        
          <div className="authorize-access__form__row form-group">
             <p className="form-group__heading">Enter your API Key *</p>
              <input
               type="text"
               name="APIKey"
               className={classnames({ 'has-error': mandatoryFieldError })}
               value={APIKey}
               onChange={this.onInputChange}
               autoComplete="false"
              />
          </div>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};